import Form from './Form';


const isConditionTrue = (name, values, condition) => {
  const { type, fieldName, params } = condition;

  if (type === 'and') {
    return condition.conditions.every(condition => isConditionTrue(name, values, condition))
  } else if (type === 'or') {
    return condition.conditions.some(condition => isConditionTrue(name, values, condition))
  } else {
    if (!fieldName) {
      console.error(`Invalid "visibility" condition for field "${name}". No "fieldName" property found in config.`);
      return true;
    }

    if (type === 'equals') {
      const fieldValue = values[Form.encodeDots(fieldName)] || '';
      const matchValue = params[0];

      if(fieldValue !== matchValue) return false;
    } else if(type === 'notEquals') {
      const fieldValue = values[Form.encodeDots(fieldName)] || '';
      const matchValue = params[0];

      if(fieldValue === matchValue) return false;
    }

    return true;
  }
}

export default class VisibilityConditionHelper {
  static isVisible(config, values) {
    const { name, visibility } = config;
    if(!visibility) return true;

    return isConditionTrue(name, values, visibility)
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/VisibilityCondition.js